import React from 'react'
import classnames from 'classnames'
import { propStyles } from '../layout/util'

import { Icon } from './Icon.react'

import * as layoutStyles from '../layout/layout.styles'
import * as bannerStyles from './styles'

const allStyles = Object.assign({}, layoutStyles, bannerStyles)

const BannerTitle = ({ children }) => {
  return <span className={classnames(bannerStyles.bannerTitle)}>{children}</span>
}

export const BannerInfo = ({ title, showIcon = false, vertical = false, children, ...props }) => {
  const { classes, props: newprops } = propStyles(props, allStyles)
  const bannerBody = vertical ? bannerStyles.bannerBodyVertical : bannerStyles.bannerBodyHorizontal
  return (
    <div className={classnames(bannerStyles.bannerBase, bannerStyles.bannerInfo, classes)} {...newprops}>
      {showIcon && <Icon className={bannerStyles.bannerIcon} type='AlertInfo' />}
      <div className={classnames(bannerBody)}>
        <BannerTitle>{title}</BannerTitle>
        {children}
      </div>
    </div>
  )
}

export const BannerAlert = ({ title, showIcon, vertical = false, children }) => {
  const bannerBody = vertical ? bannerStyles.bannerBodyVertical : bannerStyles.bannerBodyHorizontal
  return (
    <div className={classnames(bannerStyles.bannerBase, bannerStyles.bannerAlert)}>
      {showIcon && <Icon className={bannerStyles.bannerIcon} type='Alert' />}
      <div className={classnames(bannerBody)}>
        <BannerTitle>{title}</BannerTitle>
        {children}
      </div>
    </div>
  )
}
